import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=8b9752be&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=8b9752be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9752be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b9752be')) {
      api.createRecord('8b9752be', component.options)
    } else {
      api.reload('8b9752be', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=8b9752be&scoped=true&", function () {
      api.rerender('8b9752be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mZlPIkmmTQur/JS/teamMember.vue"
export default component.exports